import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { get } from '../../../lib/api';

export const useGetTileDigests = ({ limit, page, campaignId }) => {
  const params = {
    limit,
    page,
    campaign_id: campaignId,
  };

  const { data = { data: {} }, isLoading, isFetched } = useQuery(
    ['getTileDigests', params],
    () => get('/api/client_admin/tile_email_reports', params),
    {
      keepPreviousData: true,
    },
  );

  return { data, isLoading, isFetched };
};

export const useGetTileDigestTiles = ({ sortBy, sortDirection, digestId }) => {
  const newAirbo = useSelector(state => state.currentBoard.newAirbo);
  const baseParams = {
    sort_by: sortBy,
    sort_direction: sortDirection,
  };

  const params = newAirbo
    ? { ...baseParams, post_id: digestId }
    : { ...baseParams, digest_id: digestId };

  const { data = { data: {} }, isLoading } = useQuery(
    ['getTileDigestTiles', params],
    () => get('/api/client_admin/reports/all_digest_tiles', params),
    {
      keepPreviousData: true,
    },
  );

  return { data, isLoading };
};
